import React from 'react';
import {string, node, object} from 'prop-types';
import './service.css';

const Service = ({image, title, text}) => (
  <div className="service col-md-6 col-xl-4">
    <div className="thumbnail-classic">
      <img src={image.url} alt={image.alt} {...image.dimensions} />
      <div className="caption">
        <h5>{title}</h5>
        {text}
      </div>
    </div>
  </div>
);

Service.propTypes = {
  image: object.isRequired,
  title: string.isRequired,
  text: node.isRequired
};

export default Service;
